import axios from 'axios';

export default {
    calculate(productlistIds) {
        return axios.post('[API]/optimized-productlist/calculate', {
            productlists: productlistIds,
        });
    },
    list(key, offset, limit) {
        const params = {
            optimizedProductlistDefinitionKey: key,
            offset,
            limit,
        };
        return axios.get(
            '[API]/optimized-productlist/list?' + new URLSearchParams(params)
        );
    },
    fetchDetails(nr) {
        return axios.get('[API]/optimized-productlist/fetch/' + nr);
    },
    remove(nr) {
        return axios.delete('[API]/optimized-productlist/delete/' + nr);
    },
    updateSawn(nr, employeeId) {
        return axios.post('[API]/optimized-productlist/update-sawn/' + nr, {
            employeeId,
        });
    },
    updateSawnForRecord(recordId, sawn, employeeId) {
        return axios.post(
            '[API]/optimized-productlist-record/update-sawn/' + recordId,
            {
                sawn,
                employeeId,
            }
        );
    },
    fetchExport(nr) {
        return axios.get('[API]/optimized-productlist/export/' + nr);
    },
    patch(nr, data) {
        return axios.patch('[API]/optimized-productlist/patch/' + nr, data);
    },
};
